import { Component, EventEmitter, Input, OnInit, Output, ɵcoerceToBoolean } from '@angular/core';
import TournamentBase from '../../tournament-base';
import { GetTournamentCategoriesResponse } from '../../tournament.interface';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-tournament-categories',
    templateUrl: './categories.component.html',
    styleUrls: ['./categories.component.scss'],
})
export class TournamentCategoriesComponent extends TournamentBase implements OnInit {
    @Input('selection') selection: boolean;
    @Output('onSelectionChange') onSelectionChange: EventEmitter<string> = new EventEmitter();

    departmentType: string = this.getDepartmentType();
    tournamentId: string = this.route.snapshot.paramMap.get('tournamentId');
    loading: boolean = false;
    categories: GetTournamentCategoriesResponse;
    selectedCategory: boolean;

    constructor(protected route: ActivatedRoute) {
        super();
    }

    ngOnInit(): void {
        this.loading = true;
        this.tournamentService.getTournamentCategories(this.tournamentId, this.departmentType).subscribe(
            (response) => {
                this.categories = response.registers;
            },
            () => {
                //TODO: TRATAR ERRO
            },
            () => {
                this.loading = false;
            }
        );
    }

    navigateToCategory(categoryId: number | string) {
        const currentUrl = this.router.url;

        if (currentUrl.includes('/category/')) {
            // If we're already in a category route, replace the last segment
            const baseUrl = currentUrl.split('/category/')[0];
            this.router.navigate([`${baseUrl}/category/${categoryId}/detail`]);
        } else {
            // If we're not in a category route, append to current route
            this.router.navigate(['./category', categoryId, 'detail'], { relativeTo: this.route });
        }
    }
}
